import { useTestFunc } from '@carvana/test-attributes';
import Button from '@carvana/ds-button';
import {
  ButtonContainer,
  ButtonWrapper,
  ContentWrapper,
  HeaderWrapper,
  ImageWrapper,
  StyledImage,
  TextContainer,
  TextWrapper,
  TradeInWrapper
} from './TradeIn.styles';
import { APP_BASE_PATH } from 'shared/appBasePath';
import useAnalyticEvent from 'shared/hooks/useAnalyticEvent';
import getAssetUrl from 'utilities/getAssetUrl';

const TradeIn = () => {
  const { recordActionClicked } = useAnalyticEvent();
  const getTestAttributes = useTestFunc();

  const getStarted = () => {
    recordActionClicked('Landing Page', 'Trade-in, Get Started');
  };

  const imageLoader = ({ src }: { src: string }) => getAssetUrl(`${src}.webp`);

  const wizardRoute = `${APP_BASE_PATH}/getoffer/vehicle`;

  return (
    <TradeInWrapper>
      <ContentWrapper>
        <TextContainer>
          <HeaderWrapper>
            Trade in and save on your purchase
          </HeaderWrapper>
          <TextWrapper>
            Save more when you trade in the car you have for the car you want. It’s easy and all
            online.
          </TextWrapper>
          <ButtonContainer>
            <ButtonWrapper>
              <a href={wizardRoute}>
                <Button
                  variant="secondaryInverted"
                  onClick={getStarted}
                  {...getTestAttributes('GetStarted', 'TradeIn-GetStarted')}
                >
                  Get&nbsp;Started
                </Button>
              </a>
            </ButtonWrapper>
          </ButtonContainer>
        </TextContainer>
        <ImageWrapper>
          <StyledImage
            src="/images/HappyFamily"
            loader={imageLoader}
            alt="Get Your Offer"
            width={0}
            height={0}
            priority
            quality={100}
          />
        </ImageWrapper>
      </ContentWrapper>
    </TradeInWrapper>
  );
};

export default TradeIn;
